import { Link } from "react-router-dom";
import pnfImage from "../../images/icons/pnf.png";

export default function PageNotFound() {
  return (
    <div className="pnf">
      <div className="pnf__img">
        <img src={pnfImage} alt="404" />
      </div>
      <div className="pnf__desc">
        <p className="pnf__desc--title">Оййй....</p>
        <p className="pnf__desc--text">Щось пішло не так.</p>
      </div>

      <Link className="pnf__button" to="/">
        Повернутись на головну
      </Link>
    </div>
  );
}
